// 学历信息--第一学历
let degreeOptions = [
  {
    id: 0,
    label: '研究生',
    value: 1
  }, {
    id: 1,
    label: '本科',
    value: 2
  }, {
    id: 2,
    label: '大专',
    value: 3
  }, {
    id: 3,
    label: '中专',
    value: 4
  }, {
    id: 4,
    label: '高中',
    value: 5
  }
]

// 学历信息--第一学历学制
let degreeTypeOptions = [
  {
    id: 0,
    label: '全日制',
    value: 1
  }, {
    id: 1,
    label: '五大',
    value: 2
  }
]

// 单位信息--管理区域
let areaOptions = [
  {
    id: 0,
    label: '市直属',
    value: 1
  }, {
    id: 1,
    label: '罗湖区',
    value: 2
  }, {
    id: 2,
    label: '福田区',
    value: 3
  }, {
    id: 3,
    label: '南山区',
    value: 4
  }, {
    id: 4,
    label: '宝安区',
    value: 5
  }, {
    id: 5,
    label: '龙岗区',
    value: 6
  }, {
    id: 6,
    label: '盐田区',
    value: 7
  }, {
    id: 7,
    label: '龙华区',
    value: 8
  }, {
    id: 8,
    label: '坪山区',
    value: 9
  }, {
    id: 9,
    label: '光明新区',
    value: 10
  }, {
    id: 10,
    label: '大鹏新区',
    value: 11
  }
]

// 单位信息--机构类型
let agencyOptions = [
  {
    id: 0,
    label: '市级管理部门',
    value: 1
  }, {
    id: 1,
    label: '区级管理部门',
    value: 2
  }, {
    id: 2,
    label: '街道管理部门',
    value: 3
  }, {
    id: 3,
    label: '公办学校',
    value: 4
  }, {
    id: 4,
    label: '民办学校',
    value: 5
  }
]

// 任教信息--任教年级
let teachGradeOptions = ['一年级', '二年级', '三年级', '四年级', '五年级', '六年级']

// 任教信息--周课时数
let weekHoursOptions = [
  {
    id: 0,
    label: 1
  }, {
    id: 1,
    label: 2
  }, {
    id: 2,
    label: 3
  }, {
    id: 3,
    label: 4
  }, {
    id: 4,
    label: 5
  }, {
    id: 5,
    label: 6
  }, {
    id: 6,
    label: 7
  }, {
    id: 7,
    label: 8
  }, {
    id: 8,
    label: 9
  }, {
    id: 9,
    label: 10
  }, {
    id: 10,
    label: 11
  }, {
    id: 11,
    label: 12
  }, {
    id: 12,
    label: 13
  }, {
    id: 13,
    label: 14
  }, {
    id: 14,
    label: 15
  }, {
    id: 15,
    label: 16
  }
]

// 任教信息--教学特长
let teachSpecialityOptions = ['音乐', '美术', '信息技术']

// 职务信息--职称
let jobOptions = [{
  id: 1,
  label: '未评级',
  value: 0
}, {
  id: 2,
  label: '正高',
  value: 1
}, {
  id: 3,
  label: '副高',
  value: 2
}, {
  id: 4,
  label: '小高',
  value: 3
}, {
  id: 5,
  label: '小一',
  value: 4
}, {
  id: 6,
  label: '小二',
  value: 5
}]

// 职务信息--行政职务
let dutiesOptions = [
  {
    id: 1,
    label: '暂无',
    value: 0
  }, {
    id: 2,
    label: '校长',
    value: 1
  }, {
    id: 3,
    label: '副校长',
    value: 2
  }, {
    id: 4,
    label: '主任',
    value: 3
  }, {
    id: 5,
    label: '副主任',
    value: 4
  }
]

// 职务信息--业务职务
let businessOptions = ['科组长', '级组长', '备课组长', '市学科带头人', '区学科带头人', '学校学科带头人', '市中青年骨干教师', '区中青年骨干教师']

// 职务信息--编制情况
let establishmentOptions = [{
  id: 0,
  label: '正编',
  value: 1
}, {
  id: 1,
  label: '临聘',
  value: 2
}]

export default {
  degreeOptions,
  areaOptions,
  agencyOptions,
  degreeTypeOptions,
  teachGradeOptions,
  weekHoursOptions,
  teachSpecialityOptions,
  jobOptions,
  dutiesOptions,
  businessOptions,
  establishmentOptions
}
